
export const toggle = (() => {

    const toogleBtns = document.querySelectorAll("button[aria-controls]");

    //loops through all buttons and adds listener for click
    Array.from(toogleBtns).forEach((toggleBtn) => addEL(toggleBtn));

    function addEL(toggleBtn) {

        const classNames = ['video-play', 'pinsongplay'];

        if (classNames.some(className => toggleBtn.classList.contains(className)))
            return;


        const targetId = toggleBtn.getAttribute("aria-controls");
        const targetIds = targetId.split(" ");
        const multipleTargets = targetIds.length - 1;

        toggleBtn.addEventListener("click", function () {

            if (multipleTargets) {

                targetIds.forEach((element) => {
                    let targetEl = document.getElementById(element);
                    targetEl.setAttribute(
                        "aria-hidden",
                        targetEl.getAttribute("aria-hidden") === "true" ? "false" : "true"
                    );
                    targetEl.classList.toggle("hidden");
                });
            } else {

                let targetEl = document.getElementById(targetId);
                targetEl.setAttribute(
                    "aria-hidden",
                    targetEl.getAttribute("aria-hidden") === "true" ? "false" : "true"
                );
                targetEl.classList.toggle("hidden");
            }

            const allBtns = document.querySelectorAll(
                '[aria-controls="' + targetId + '"]'
            );

            Array.from(allBtns).forEach((b) => {
                b.setAttribute(
                    "aria-expanded",
                    b.getAttribute("aria-expanded") === "true" ? "false" : "true"
                );
            });
        });
    }
})();
